import { render, staticRenderFns } from "./NoncurrentAssets.vue?vue&type=template&id=e8783462"
import script from "./NoncurrentAssets.vue?vue&type=script&lang=js"
export * from "./NoncurrentAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports